// @flow

import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';

import theme from '../../../config/themes/vortex';

import PrivateRoute from '../../../components/PrivateRoute';

import Calculator from './views/Calculator';
import Landing from './views/Landing';
import NotFound from '../../../views/NotFound';

const VortexWrapper = styled.div`
  background: white;
`;

class VortexTool extends Component<{}> {

  render() {
    return (
      <VortexWrapper>
        <ThemeProvider theme={theme}>
          <Switch>
            <Route component={Landing} path="/tools/vortex/" exact={true} />
            <PrivateRoute
              component={Calculator}
              path="/tools/vortex/calculator"
              exact={true}
            />
            <Route render={props => (
              <NotFound to="/tools/vortex" toContext="the Vortex Speed Reducers landing page" />
            )} />
          </Switch>
        </ThemeProvider>
      </VortexWrapper>
    );
  }

}

export default VortexTool;



// WEBPACK FOOTER //
// ./src/views/tools/vortex/index.js